
import { Link } from 'react-router-dom';
import { localDeals } from '../../../../mocks/deals';

interface SimilarDealsProps {
  currentDealId: number;
  category: string;
}

export default function SimilarDeals({
  currentDealId,
  category,
}: SimilarDealsProps) {
  const similar = localDeals
    .filter((d) => d.id !== currentDealId)
    .sort((a, b) => {
      if (a.category === category && b.category !== category) return -1;
      if (a.category !== category && b.category === category) return 1;
      return b.claimed - a.claimed;
    })
    .slice(0, 4);

  if (similar.length === 0) return null;

  return (
    <section className="py-16 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              You Might Also Like
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              More great deals from Roseville businesses
            </p>
          </div>
          <Link
            to="/deals"
            className="text-sm text-teal-600 font-semibold hover:text-teal-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            View All Deals
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {similar.map((deal) => (
            <Link
              key={deal.id}
              to={`/deals/${deal.id}`}
              className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={deal.image}
                  alt={`${deal.dealTitle} at ${deal.businessName}`}
                  title={`${deal.businessName} deal Roseville CA`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-red-500 text-white text-[10px] font-bold rounded-full">
                    {deal.discountPercent === 100
                      ? 'FREE'
                      : `${deal.discountPercent}% OFF`}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <p className="text-xs text-gray-500 mb-1 truncate">
                  {deal.businessName}
                </p>
                <h3 className="text-sm font-bold text-gray-900 mb-2 truncate group-hover:text-teal-700 transition-colors">
                  {deal.dealTitle}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-baseline gap-1.5">
                    {deal.dealPrice > 0 ? (
                      <>
                        <span className="text-base font-bold text-teal-700">
                          ${deal.dealPrice}
                        </span>
                        <span className="text-xs text-gray-400 line-through">
                          ${deal.originalPrice}
                        </span>
                      </>
                    ) : (
                      <span className="text-base font-bold text-teal-700">
                        FREE
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs font-semibold text-gray-700">
                      {deal.rating}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
